import React, { useState, useEffect } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import styled from "styled-components";
import { useTranslation } from "react-i18next";
import Header from "./Header";
import Footer from "./Footer";

const ResetPassword = () => {
  const { t } = useTranslation();
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const token = searchParams.get("token");

  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [message, setMessage] = useState("");
  const [success, setSuccess] = useState(false);

  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);

  useEffect(() => {
    if (!token) {
      setMessage(t("resetPassword.errors.invalidToken"));
    }
  }, [token, t]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setMessage("");

    if (newPassword !== confirmPassword) {
      return setMessage(t("resetPassword.errors.passwordsDontMatch"));
    }

    try {
      const API_URL = process.env.REACT_APP_API_URL || "http://localhost:8000/";
      const response = await fetch(`${API_URL}reset-password`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ token, newPassword }),
      });

      const data = await response.json();
      if (response.ok) {
        setSuccess(true);
        setMessage(t("resetPassword.success"));
        setTimeout(() => navigate("/login"), 3000);
      } else {
        setMessage(data.message || t("resetPassword.errors.genericError"));
      }
    } catch (err) {
      setMessage(t("resetPassword.errors.networkError"));
    }
  };

  return (
    <div>
      <Header />
      <Wrapper>
        <Form onSubmit={handleSubmit}>
          <Title>{t("resetPassword.title")}</Title>

          <InputWrapper>
            <Input
              type={showPassword ? "text" : "password"}
              placeholder={t("resetPassword.placeholders.newPassword")}
              value={newPassword}
              onChange={(e) => setNewPassword(e.target.value)}
              required
            />
            <EyeButton
              onClick={(e) => {
                e.preventDefault();
                setShowPassword(!showPassword);
              }}
            >
              👁
            </EyeButton>
          </InputWrapper>

          <InputWrapper>
            <Input
              type={showConfirmPassword ? "text" : "password"}
              placeholder={t("resetPassword.placeholders.confirmPassword")}
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
              required
            />
            <EyeButton
              onClick={(e) => {
                e.preventDefault();
                setShowConfirmPassword(!showConfirmPassword);
              }}
            >
              👁
            </EyeButton>
          </InputWrapper>

          <Button type="submit">{t("resetPassword.submitButton")}</Button>
          {message && <Message success={success}>{message}</Message>}
        </Form>
      </Wrapper>
      <Footer />
    </div>
  );
};

export default ResetPassword;

const Wrapper = styled.div`
  min-height: 80vh;
  display: flex;
  justify-content: center;
  align-items: center;
  background:linear-gradient(122deg, rgba(148,163,135,1) 0%, rgba(186,204,171,1) 43%, rgba(246,187,155,1) 83%, rgba(217,121,97,1) 100%);
`;

const Form = styled.form`
  background-color: rgba(255,255,255,0.9);
  padding: 30px;
  border-radius: 8px;
  box-shadow: 0px 4px 8px rgba(0,0,0,0.1);
  display: flex;
  flex-direction: column;
  gap: 15px;
`;

const Title = styled.h2`
  margin: 0;
  text-align: center;
`;

const Input = styled.input`
  padding: 10px;
  font-size: 16px;
  border-radius: 5px;
  border: 1px solid gray;
`;

const Button = styled.button`
  padding: 10px;
  background-color: rgba(148,163,135,1);
  color: white;
  font-weight: bold;
  border: none;
  border-radius: 5px;
  cursor: pointer;
`;

const Message = styled.p`
  text-align: center;
  font-weight: bold;
  color: ${({ success }) => (success ? "green" : "red")};
`;
const InputWrapper = styled.div`
  position: relative;
`;

const EyeButton = styled.button`
  position: absolute;
  top: 50%;
  right: 10px;
  transform: translateY(-50%);
  background: none;
  border: none;
  font-size: 18px;
  cursor: pointer;
`;